import React from 'react'
import PropTypes from 'prop-types'

import Moment from 'moment'

import NavHighlighter from 'components/NavHighlighter'

const Item = props => (
  <tr>
    <td> {props.indexKey + 1} </td>
    <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
    <td> <span className="capitalize">{props.row.service.name} </span></td>
    <td> <span className="capitalize">{props.row.name} </span></td>
    <td>
      <NavHighlighter
        className="btn btn-icon-only dark"
        to={`/formats/${props.row.id}/edit`}
        pathname={props.pathname}
        noli
      >
        <i className="fa fa-pencil" />
      </NavHighlighter>
    </td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    createdAt: '',
    name: '',
    service: {
      name: '',
    },
  },
  pathname: '',
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    service: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  pathname: PropTypes.string.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
